import _ from 'lodash';
import React, {Component } from 'react';
import PropTypes from 'prop-types';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

//- Containers
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import FormContainer from "../../components/FormContainer";
import LocationSelect from "../../components/advancedForm/LocationSelect";
import FormSubmitButton from "../../components/form/FormSubmitButton";
import FormCheckbox from "../../components/form/FormCheckbox";
import ShiftSelect from "../../components/advancedForm/ShiftSelect";
import {post} from "../../modules/utility";

const styles = () => {
	return {};
};

class SetupDriverRoomSchedule extends Component {
	constructor(props) {
		super(props);
		this.requiredPathMap = {};
		this.state = {};
	}

	goToUrl = () => {
		const { showErrors } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({path, label})=> {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		const { locationId, shiftId, useSecurityToken } = this.state;

		if (!useSecurityToken) {
			this.props.history.push(
				`/minimal/driverRoomSchedule/${locationId}/${shiftId}`
			);
			return;
		}

		post({
			method: 'securityToken.get',
			params: {
				tokenType: 'schedule'
			},
			callback: (err, r) => {
				if (err) {
					return showErrors(err);
				}

				const {scheduleToken} = r;
				if (!scheduleToken) {
					return showErrors(['Security token not returned']);
				}
				this.props.history.push(
					`/minimal/driverRoomSchedule/${locationId}/${shiftId}/${scheduleToken}`
				);
			}
		});
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	setForm = (path, label, isRequired, defaultValue) => {
		if (isRequired) {
			this.requiredPathMap[path] = { path, label};
		}
		return {
			key : path,
			path,
			label,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render () {
		const {permissions} = this.props;

		if (!permissions || !_.includes(permissions,'canUpdateScheduling')) {
			return (<div>You do not have valid permissions to view this page.</div>);
		}

		return (<FormContainer headline={`Get Driver Room URL`}>
				<Grid item md={12}>
					<div style={{marginBottom : 30 }}>
						If you select "Include URL AUth Token" then this URL can be used without
						logging into Sphere as the URL contains the auth token.
					</div>
				</Grid>

				<LocationSelect
					{...this.setForm('locationId', 'Pick Terminal', true)}
				/>

				<ShiftSelect
					{...this.setForm('shiftId', 'Pick Shift', true)}
				/>

				<FormCheckbox
					{...this.setForm('useSecurityToken', 'Include URL Auth Token', false, false)}
				/>

				<FormSubmitButton
					onClick={this.goToUrl}
					buttonText={`Go to Driver Room URL`}
				/>
		</FormContainer>);
	}
}

SetupDriverRoomSchedule.propTypes = {
	showErrors : PropTypes.func.isRequired,
	authUser : PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
])(SetupDriverRoomSchedule);
